(function () {
  'use strict';
  var d = document, root = d.documentElement, w = window;
  var mq = function (q) { return !!(w.matchMedia && w.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var narrow = mq('(max-width: 760px)');
  var started = false;
  function all(sel, ctx) { return [].slice.call((ctx || d).querySelectorAll(sel)); }
  function els(x, ctx) { return typeof x === 'string' ? all(x, ctx) : [].concat(x).filter(Boolean); }
  function tag(sel, kind, opt) {
    opt = opt || {};
    return els(sel, opt.ctx).map(function (el, i) {
      el.setAttribute('data-mo', kind);
      var dl = (opt.d || 0) + (opt.step || 0) * i;
      if (dl) el.style.setProperty('--mo-d', dl.toFixed(2) + 's');
      return el;
    });
  }
  function count(sel, needle, opt) {
    var el = typeof sel === 'string' ? d.querySelector(sel) : sel;
    if (!el) return null;
    var walk = d.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = walk.nextNode())) {
      var i = n.data.indexOf(needle);
      if (i < 0) continue;
      var mid = n.splitText(i);
      mid.splitText(needle.length);
      var s = d.createElement('span');
      s.className = 'mo-num';
      s.setAttribute('data-mo-count', '');
      if (opt && opt.from != null) s.setAttribute('data-mo-from', opt.from);
      s.textContent = needle;
      mid.parentNode.replaceChild(s, mid);
      return s;
    }
    return null;
  }
  function add(sel, html, where) {
    var p = typeof sel === 'string' ? d.querySelector(sel) : sel;
    if (!p) return null;
    p.insertAdjacentHTML(where || 'beforeend', html);
    return where === 'afterbegin' ? p.firstElementChild : p.lastElementChild;
  }
  function particles(sel, n, cls) {
    var h = '';
    for (var i = 0; i < n; i++) {
      h += '<i style="--x:' + (Math.random() * 100).toFixed(1) + '%;--y:' + (Math.random() * 100).toFixed(1) +
        '%;--s:' + (2 + Math.random() * 3).toFixed(1) + 'px;--t:' + (7 + Math.random() * 7).toFixed(1) +
        's;--dl:-' + (Math.random() * 14).toFixed(1) + 's"></i>';
    }
    return add(sel, '<div class="' + (cls || 'mo-pt') + '" aria-hidden="true">' + h + '</div>', 'afterbegin');
  }
  function runCount(el) {
    var txt = el.textContent, m = txt.match(/\d[\d,]*(\.\d+)?/);
    if (!m) return;
    var raw = m[0], dec = (raw.split('.')[1] || '').length, comma = raw.indexOf(',') > -1;
    var to = parseFloat(raw.replace(/,/g, '')), from = +(el.getAttribute('data-mo-from') || 0);
    var pre = txt.slice(0, m.index), post = txt.slice(m.index + raw.length);
    var dur = +(el.getAttribute('data-mo-dur') || 1.6) * 1000, t0 = null;
    function fmt(v) {
      var s = v.toFixed(dec);
      if (comma) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); }
      return pre + s + post;
    }
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = k < 1 ? fmt(from + (to - from) * e) : txt;
      if (k < 1) w.requestAnimationFrame(step);
    }
    el.textContent = fmt(from);
    w.requestAnimationFrame(step);
  }
  function scrollLinked() {
    var par = narrow ? [] : all('[data-mo-par]'), drift = all('[data-mo-drift]');
    if (!par.length && !drift.length) return;
    var vh = w.innerHeight, ticking = false;
    function prog(el) {
      var r = el.parentElement.getBoundingClientRect();
      return Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
    }
    function update() {
      ticking = false;
      par.forEach(function (el) {
        el.style.translate = '0 ' + ((0.5 - prog(el)) * 2 * +el.getAttribute('data-mo-par')).toFixed(1) + 'px';
      });
      drift.forEach(function (el) {
        el.style.translate = ((0.5 - prog(el)) * 2 * +el.getAttribute('data-mo-drift')).toFixed(1) + 'px 0';
      });
    }
    function req() { if (!ticking) { ticking = true; w.requestAnimationFrame(update); } }
    w.addEventListener('scroll', req, { passive: true });
    w.addEventListener('resize', function () { vh = w.innerHeight; req(); });
    update();
  }
  function start() {
    if (started) return;
    started = true;
    if (reduce || !('IntersectionObserver' in w)) { root.classList.add('mo-off'); return; }
    root.classList.add('mo-on');
    var proxied = new Map();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        io.unobserve(t);
        (proxied.get(t) || []).forEach(function (el) { el.classList.add('mo-in'); });
        if (t.matches('[data-mo],[data-mo-count],[data-mo-play]')) t.classList.add('mo-in');
        if (t.hasAttribute('data-mo-count')) runCount(t);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    all('[data-mo],[data-mo-count],[data-mo-play]').forEach(function (el) {
      var p = el.getAttribute('data-mo') === 'mask' && el.parentElement;
      if (p) { proxied.set(p, (proxied.get(p) || []).concat(el)); io.observe(p); }
      else io.observe(el);
    });
    scrollLinked();
  }
  w.FJKMotion = { tag: tag, count: count, add: add, particles: particles, start: start, all: all, reduce: reduce, narrow: narrow };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
})();
